import QueryString from 'query-string';
import snakecaseKeys from 'snakecase-keys';

import { buildQueryParams as buildCustomFieldQueryParams } from 'bundles/comps/index/custom_fields/helpers';
import { get } from 'helpers/api';
import { stringify } from 'helpers/query_string_helpers';
import debounceActionCreators from 'helpers/redux/debounce_action_creators';
import RansackQuery from 'helpers/ransack_query';
import { isEmpty } from 'lodash';
import { industrialKeys, keys, leaseKeys, retrieveFilterOptions, saleKeys } from 'helpers/comps/api_helpers';

const debouncedRetrieveLeases = debounceActionCreators({ retrieveLeases }, 1000);
const debouncedRetrieveSales = debounceActionCreators({ retrieveSales }, 1000);

export const CHANGE_RECORDS = 'CHANGE_RECORDS';
export function changeRecords(sales, leases, meta) {
  return {
    leases,
    sales,
    meta,
    type: CHANGE_RECORDS
  };
}

export const RETRIEVE_RECORDS_STARTED = 'RETRIEVE_RECORDS_STARTED';
export function retrieveRecordsStarted() {
  return { type: RETRIEVE_RECORDS_STARTED };
}

export function retrieveLeases() {
  return (dispatch, getState) => {
    dispatch(retrieveRecordsStarted());
    const { coordinates, paths, query, scope, ui } = getState();
    const filterOptions = retrieveFilterOptions(query, scope, ui.currentTab);
    const ransackQuery = new RansackQuery(
      filterOptions,
      { ...keys, ...leaseKeys, ...industrialKeys }
    ).toRansack();
    let path = paths.leases;
    const coordinatesQuery = isEmpty(coordinates.userBounds) ? coordinates.mapBounds : coordinates.userBounds;
    if (!isEmpty(coordinatesQuery)) {
      path = `${path}?${stringify(snakecaseKeys({ coordinates: coordinatesQuery }), { nested: true })}`;
    }
    get(path, { params: { ...ransackQuery, ...getCustomFieldQueryParams(getState) } })
      .then((response) => {
        dispatch(changeRecords([], response.leases, response.meta));
      });
  };
}

export function retrieveSales() {
  return (dispatch, getState) => {
    dispatch(retrieveRecordsStarted());
    const { coordinates, paths, query, scope, ui } = getState();
    const filterOptions = retrieveFilterOptions(query, scope, ui.currentTab);
    const ransackQuery = new RansackQuery(filterOptions, { ...keys, ...saleKeys, ...industrialKeys }).toRansack();
    let path = paths.sales;
    const coordinatesQuery = isEmpty(coordinates.userBounds) ? coordinates.mapBounds : coordinates.userBounds;
    if (!isEmpty(coordinatesQuery)) {
      path = `${path}?${stringify(snakecaseKeys({ coordinates: coordinatesQuery }), { nested: true })}`;
    }
    get(path, { params: { ...ransackQuery, ...getCustomFieldQueryParams(getState) } })
      .then((response) => {
        dispatch(changeRecords(response.sales, [], response.meta));
      });
  };
}

export function delayRetrieveRecords() {
  return (dispatch, getState) => {
    const { ui } = getState();
    if (ui.currentTab === 'lease') {
      debouncedRetrieveLeases.retrieveLeases(dispatch);
    } else {
      debouncedRetrieveSales.retrieveSales(dispatch);
    }
  };
}

export function downloadLeasesAsCSV() {
  return (_dispatch, getState) => {
    const { paths, query, scope, selectList, ui } = getState();
    const filterOptions = retrieveFilterOptions(query, scope, ui.currentTab);
    const ransackQuery = new RansackQuery(filterOptions, { ...keys, ...leaseKeys }).toRansack();
    const selected = selectList.selectedLeaseIds;
    const queryString = QueryString.stringify({
      ...ransackQuery,
      ...getCustomFieldQueryParams(getState),
      selected,
    }, { arrayFormat: 'bracket' });

    window.location.assign(`${paths.leasesToCsv}?${queryString}`);
  };
}

export function downloadSalesAsCSV() {
  return (_dispatch, getState) => {
    const { paths, query, scope, selectList, ui } = getState();
    const filterOptions = retrieveFilterOptions(query, scope, ui.currentTab);
    const ransackQuery = new RansackQuery(filterOptions, { ...keys, ...saleKeys }).toRansack();
    const selected = selectList.selectedSaleIds;
    const queryString = QueryString.stringify({
      ...ransackQuery,
      ...getCustomFieldQueryParams(getState),
      selected,
    }, { arrayFormat: 'bracket' });

    window.location.assign(`${paths.salesToCsv}?${queryString}`);
  };
}

function getCustomFieldQueryParams(getState) {
  const state = getState();
  return buildCustomFieldQueryParams(state.customFieldSchemas, state.query.customFieldFilters, state.ui.currentTab);
}
